import React from 'react'
import cn from 'classnames'

import st from './index.scss'
import { useType } from '@/hooks'

import { Link } from '@/components'

export default function Footer({ className }) {
  const type = useType()
  return (
    <div className={cn(st['zh-footer'], className)}>
      <div className={cn(st['footer-con'], st['clear'])}>
        <div className={st['course_lists']}>
          <ul>
            <li>
              <a href={`/${type}/book`} target="_blank">
                图书
              </a>
            </li>
            <li>
              <a href={`/${type}/open`} target="_blank">
                公开课
              </a>
            </li>
            <li>
              <a href={`/${type}/wangshou`} target="_blank">
                网授课
              </a>
            </li>
            <li>
              <a href={`/${type}/mianshou`} target="_blank">
                面授课
              </a>
            </li>
          </ul>
        </div>
        <div className={st['course_lists']}>
          <ul>
            <li>
              <a href={`/${type}/teacher`} target="_blank">
                众合师资
              </a>
            </li>
            {
              type=='fakao' && (
                <li >
                  <a href="/fakao/news" target="_blank">
                    众合资讯
                  </a>
                </li>
              )
            }
            <li>
              {/* <a href={`/${type}/branchCampus`} target="_blank">
                全国分校
              </a> */}
              <a href={`/${type}/${type == 'fakao' ? 'branchCampus' : 'rich-text?id=22'}`} target="_blank">
              { type == 'fakao' ? '全国分校' : '教学计划' }
              </a>
            </li>
            <li>
              <a href={`/${type}/about`} target="_blank">
                关于众合
              </a>
            </li>
          </ul>
        </div>
        <div className={st['course_lists']}>
          <ul>
            <li>
              <a
                href={`/${type}/mall/recruit/home`} 
                target="_blank"
              >
                众合招聘
              </a>
            </li>
            <li>
              <a href={`/${type}/cooperate`} >
                合作单位
              </a>
            </li>
            <li>
              <a href={`/download`} >
                App下载
              </a>
            </li>
          </ul>
        </div>
        <div className={st['course_lists']}>
          <ul>
            <p>
              <a>服务电话：400 6116 858</a>
            </p>
            <p>
              <a>加盟电话：15810278093</a>
            </p>
          </ul>
        </div>
        <div className={st['guanzhu-us']}>
          <p className={st['guanzhu-tit']}>
            <a>
              关注我们
            </a>
          </p>
          <ul className={st['clear']}>
            <li
              style={{
                marginRight: '54px'
              }}
            >
              <img
                src="https://osscdn2.zhongheschool.com/common/defaultType/202312/202312111131480300.png"
                style={{
                  width: '106px'
                }}
              />
              <p
                className={st.ppp}
              >
                众合在线APP
              </p>
            </li>
            <li>
              <img
                src="https://osscdn2.zhongheschool.com/common/defaultType/202312/202312092020370693.png"
                style={{
                  width: '106px'
                }}
              />
              <p
                className={st.ppp}
              >
                竹马APP
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div className={st['footer-copyright']}>
        <p className={st['copyright']}>
          Copyright © 2007 - {new Date().getFullYear()} Zhongheschool. All Rights Reserved.
        </p>
        <div style={{display:'flex',justifyContent:'center'}}>
          课程内容版权均归<em>北京方圆众合教育科技有限公司</em>所有
          <Link
              className={st['jing']}
              to="http://beian.miit.gov.cn"
              useorigin={true}
          >
              京ICP备09112622号-5
          </Link>
          <Link
              className={st['jing']}
              style={{display:'flex'}}
              to="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802030992"
              useorigin={true}
          >
              <img style={{width:'15px',height:'15px',margin:'4px'}} src="https://osscdn.zhongheschool.com/assets/beianIcon.png"></img>
              <div>京公网安备 11010802030992号</div>
          </Link>
        </div>
        <p>北京市海淀区苏州街3号大恒科技大厦北座6层</p>
      </div>
    </div>
  )
}
